import styled from 'styled-components';

export const SeparatorWrapper = styled.div`
  text-align: center;
  position: relative;
  margin: 20px 0;
`;

export const SeparatorText = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: #fff;
  padding: 0 20px;
  font-weight: 700;
`;

export const HRSeparator = styled.hr`
  border-top: 2px solid #dfdfdf;
  width: 50%;
  margin: auto;
`;
